module.exports = __webpack_public_path__ + "static/media/pop_XW.a4b9f535.svg";